import React from 'react';
import './Guide.css';
import step1 from './images/step1.png';
import step2 from './images/step2.png';
import step3 from './images/step3.png';
import HeaderEbill from './HeaderEbill';
import FooterEbill from './FooterEbill';

const Guide = () => {
  return (
    <>
     <HeaderEbill/>
    <div className="guide-container">
      <h2 className="guide-title">
        <span role="img" aria-label="document">📘</span> How to retrieve OTP from ZATCA’s Fatoora’s Portal
      </h2>

      <ol className="guide-steps">
        <li>
          To authenticate your Company in OneExpress, you must confirm that you are the owner of the company being added to OneExpress by completing the steps below:
        </li>

        <li>
          Login to your account in ZATCA’s Fatoora Portal. <br />
          Navigate to <strong>Onboard New Solution Unit/Device</strong>.
        </li>

        <div className="guide-image-box">
          <img src={step1} alt="Onboard new solution or CSC" className="guide-image" />
        </div>

        <li>
          Enter the number of devices you want to onboard
        </li>

        <div className="guide-image-box">
          <img src={step2} alt="Enter device count and generate OTP" className="guide-image" />
        </div>

        <li>
          Copy the generated <strong>OTP</strong> and enter it in the designated field in OneExpress.
        </li>

        <div className="guide-image-box">
          <img src={step3} alt="Copy OTP" className="guide-image" />
        </div>
      </ol>
    </div>
    <FooterEbill/>
    </>
  );
};

export default Guide;
